import styled from 'styled-components';

export const HeaderViewContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
`;

export const HeaderFilterContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
`;

export const HeaderActions = styled.div`
    display: flex;
`;